import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const TbBetweenIcon = () => {
    return (
        <SvgIcon>
            <polygon points="10.97 7.1 9.93 6.06 5.03 10.96 5.02 10.96 3.98 12 9.89 17.94 10.94 16.91 6.06 12.01 10.97 7.1" />
            <polygon points="13.03 7.1 14.07 6.06 18.98 10.96 18.98 10.96 20.02 12 14.11 17.94 13.06 16.91 17.94 12.01 13.03 7.1" />
        </SvgIcon>
    );
};
